const actionsNoCare = [
  "CHANGE_LAYOUT",
  "CHANGE_TOPBAR_THEME",
  "CHANGE_SIDEBAR_THEME",
  "CHANGE_SIDEBAR_THEME_IMAGE",
  "CHANGE_LAYOUT_WIDTH",
  "CHANGE_LAYOUT_MODE",
  "CHANGE_SIDEBAR_TYPE",
  "SHOW_RIGHT_SIDEBAR",
]

export { actionsNoCare }
